import { render, staticRenderFns } from "./AsociarMensajesFormEdit2.vue?vue&type=template&id=0c5b9d58&scoped=true&"
import script from "./AsociarMensajesFormEdit2.vue?vue&type=script&lang=ts&"
export * from "./AsociarMensajesFormEdit2.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarMensajesFormEdit2.vue?vue&type=style&index=0&id=0c5b9d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b9d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0c5b9d58', component.options)
    } else {
      api.reload('0c5b9d58', component.options)
    }
    module.hot.accept("./AsociarMensajesFormEdit2.vue?vue&type=template&id=0c5b9d58&scoped=true&", function () {
      api.rerender('0c5b9d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Ruta/AsociarMensajesFormEdit2.vue"
export default component.exports